import { PERMISSION_MODULES } from '../constants/roleConstants'
import { cn }                  from '@utils'

// ── Module row ─────────────────────────────────────────────────────────────────

function ModuleRow({ module, selected, readOnly, onChange }) {
  const moduleKeys = module.permissions.map((p) => p.key)
  const allChecked = moduleKeys.every((k) => selected.includes(k))
  const anyChecked = moduleKeys.some((k) => selected.includes(k))

  function toggleModule() {
    if (allChecked) {
      onChange(selected.filter((p) => !moduleKeys.includes(p)))
    } else {
      const added = [...new Set([...selected, ...moduleKeys])]
      onChange(added)
    }
  }

  function togglePermission(key) {
    if (selected.includes(key)) {
      onChange(selected.filter((p) => p !== key))
    } else {
      onChange([...selected, key])
    }
  }

  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--ac-border-base)', background: 'var(--ac-bg-base)' }}
    >
      {/* Module header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold" style={{ color: 'var(--ac-text-base)' }}>
          {module.label}
        </span>
        {!readOnly && (
          <label className="flex items-center gap-1.5 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={allChecked}
              ref={(el) => { if (el) el.indeterminate = anyChecked && !allChecked }}
              onChange={toggleModule}
              className="w-3.5 h-3.5 rounded accent-[var(--ac-secondary)] cursor-pointer"
            />
            <span className="text-xs" style={{ color: 'var(--ac-text-muted)' }}>
              {allChecked ? 'Deselect all' : 'Select all'}
            </span>
          </label>
        )}
      </div>

      {/* Permission checkboxes */}
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {module.permissions.map((perm) => {
          const checked = selected.includes(perm.key)
          return (
            <label
              key={perm.key}
              className={cn(
                'flex items-center gap-2 text-xs select-none',
                readOnly ? 'cursor-default' : 'cursor-pointer',
              )}
            >
              <input
                type="checkbox"
                checked={checked}
                disabled={readOnly}
                onChange={() => !readOnly && togglePermission(perm.key)}
                className="w-3.5 h-3.5 rounded accent-[var(--ac-secondary)] disabled:cursor-default"
              />
              <span
                style={{
                  color: checked ? 'var(--ac-text-base)' : 'var(--ac-text-muted)',
                  fontWeight: checked ? 500 : 400,
                }}
              >
                {perm.label}
              </span>
            </label>
          )
        })}
      </div>
    </div>
  )
}

// ── PermissionMatrix ───────────────────────────────────────────────────────────

export function PermissionMatrix({ permissions = [], onChange, readOnly = false }) {
  return (
    <div className="space-y-3">
      {PERMISSION_MODULES.map((module) => (
        <ModuleRow
          key={module.id}
          module={module}
          selected={permissions}
          readOnly={readOnly}
          onChange={onChange}
        />
      ))}
    </div>
  )
}
